<template>
    <div class="w-full">
        <div class="mb-4 flex items-center justify-between">
            <h2 class="text-4xl text-[#2b2b2b]">Revues</h2>
        </div>
        <div class="bg-white rounded-lg px-4 py-6 mb-3 text-[#2b2b2b]">
            <h3 class="text-2xl underline">Lancer une nouvelle session</h3>
            <form @submit.prevent="createReviewSession" class="flex items-end gap-x-3 justify-between mt-3">
                <div class="grow flex flex-col items-start ">
                    <label for="Libelle" class="font-light" >Libelle<span class="text-[#f44545]">*</span></label>
                    <input type="text" placeholder="Définir la session" v-model="form.title" name="Libelle" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>

                <button type="submit" class="py-4 rounded-md w-[30%] text-white bg-[#5357ec]">
                    <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                    <span v-if="!asSend">Enregistrer</span>
                </button>
            </form>
        </div>
        <div class="bg-white rounded-lg px-4 py-6 mb-3 text-[#2b2b2b]">
            <div class="flex items-center justify-between">
                <h3 class="text-2xl underline">Liste des revues</h3>
                <div class="w-[30%] flex flex-col items-start ">
                    <select v-model="selectedPeriod" name="contrat" id="contrat" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                        <option value="">Sélectionner la session</option>
                        <option v-for="(review,idx) in reviews" :key="review.id" :value="idx"> 
                            {{ review.title }} 
                        </option>
                    </select>
                </div>
            </div>
            <div v-if="this.reviews.length == 0" class="alert bg-black mt-3">
                    <center>Pas de données trouvées</center>
            </div>
            <div v-else-if="reviews[selectedPeriod].reviews.length == 0" class="alert bg-black mt-3">
                <center>Pas de revue associé à cette période</center>
            </div>
            <div v-else class="body mt-3">
                <div class="table-responsive" v-if="!isLoading">
                    <table class="table table-bordered table-striped table-hover tableEmployee">
                        <thead>
                            <tr>
                                <th>Nom</th>
                                <th>Prenom</th>
                                <th>Note</th>
                                <th>Avis Responsable</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="review in reviews[selectedPeriod].reviews" :key="review.id">
                                <td>
                                    <div class="form-line">
                                       {{ review.user.first_name }}
                                    </div>
                                </td>
                                <td>
                                    <div class="form-line">
                                        {{ review.user.last_name }}
                                    </div>
                                </td>
                                <td>
                                    <div class="form-line">
                                        {{ review.mark ?? "Attente retour supérieur" }}
                                    </div>
                                </td>
                                <td>
                                    <div class="form-line">
                                        {{ review.sup_commentary ?? "Attente retour supérieur" }}
                                    </div>
                                </td>
                                <td>
                                    <div class="form-line">
                                        <button v-on:click="pushDetailPage(review.id)" class="px-4 py-2 rounded-lg bg-[#5357ec] text-white">Voir détails</button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div style="display: flex; justify-content:center" v-else>
                    <div class="preloader pl-size-xs">
                        <div class="spinner-layer pl-indigo">
                            <div class="circle-clipper left">
                                <div class="circle"></div>
                            </div>
                            <div class="circle-clipper right">
                                <div class="circle"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import toast from '@/components/ui/toast';
import API from '@/service/API';
import {
    Loader2
} from "lucide-vue-next";
export default {
    name:"HRReview",
    components:{
        Loader2
    },
    data(){
        return {
            asSend:false,
            form:{
                title:"",
            },
            reviews:[],
            selectedPeriod:0,
        }
    },
    mounted(){
        this.getAllReviewSession();
    },
    methods:{
        clearForm(){
            this.form.libelle = "";
        },
        createReviewSession(){
            this.asSend = true;
            API.post('/sessions',this.form)
            .then((data)=>{
                if(data.data["status"]){
                    toast.success("Succès","Session ajouté",3000);
                    this.getAllReviewSession();
                    this.clearForm();
                }else{
                    toast.error("Oops..",data.data["message"],4000)
                }
            })
            .catch(()=>{
                toast.error("Oops..","Il semble avoir une erreur, merci de réessayé.",4000)
            })
            .finally(()=>{this.asSend = false})
        },
        getAllReviewSession(){
            API.get('/sessions')
            .then((data)=>{
                if(data.data["status"]){
                    this.reviews = data.data["data"];
                }else{
                    toast.error("Oops..",data.data["message"],4000)
                }
            })
            .catch(()=>{
                toast.error("Oops..","Il semble avoir une erreur, merci de réessayé.",4000)
            })
        },
        pushDetailPage(id){
            this.$router.push({
                name:"detail-hr-review",
                params:{
                    id:id
                }
            })
        }
    },
}
</script>